import {tgxApi} from "../../../app/tgxApi";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {
    getAuthorizationHeader, getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {downloadFile} from "../../../helpers/utils/FileUtils";


export const stateCodeAliasApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchAllStateCodeAlias: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/state-code-alias/search?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['stateCodeAlias'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getStateCodeAliasById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-state-code-alias-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['stateCodeAliasById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        createStateCodeAlias: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/state-code-alias/create`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['stateCodeAlias'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "State Code Alias")
            },
        }),

        updateStateCodeAlias: build.mutation({
            query: ({id, requestBody}) => {
                return {
                    url: `/ajax/update-state-code-alias-by-id/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['stateCodeAlias', 'stateCodeAliasById','userAuditableInfo'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "State Code Alias")
            },
        }),

        deleteStateCodeAliasByIdService: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-state-code-alias-by-id/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['stateCodeAlias', 'stateCodeAliasById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "State Code Alias");
            },
        }),



    }),
});

export const {useSearchAllStateCodeAliasQuery,
    useGetStateCodeAliasByIdQuery,
    useUpdateStateCodeAliasMutation,
    useCreateStateCodeAliasMutation,
    useDeleteStateCodeAliasByIdServiceMutation,
}=stateCodeAliasApi